export const phoneIsValid = phone => ((/^\(?[2-9]\d{2}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/).test(phone.toUpperCase()) && phone.trim().length <= 25 && phone.trim().length >= 10);

export const zipIsValid = (country, zip) => {
	const zipFormats = {
		CA: /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/,
		MX: /^\d{5}$/,
		// Manually verified as safe
		// eslint-disable-next-line security/detect-unsafe-regex
		US: /^[0-9]{5}(?:-[0-9]{4})?$/
	};

	const zipRegex = zipFormats[country];
	return zipRegex ? zipRegex.test(zip) : zipFormats.US.test(zip);
};

export const allowedPrefContactMethods = (allowEmpty, phoneType) => {
	let empty = allowEmpty ? [''] : [];

	return phoneType === 'mobile' ?
		['phone', 'sms', 'email', ...empty] :
		['phone', 'email', ...empty];
};
